// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.load-progress-bar-container {
    position: absolute;
    bottom: 0;
    right: 0;
}
.border {
    box-sizing: border-box;
    height: 26px;
    text-size-adjust: 100%;
    width: 382px;
    perspective-origin: 191px 13px;
    transform-origin: 191px 13px;
    border: 1px solid #ccc;
    border-radius: 5px;
}
@media (max-width: 767px) {
.border {
        width: 100%;
}
.load-progress-bar-container {
        width: 100%;
}
}
.progress {
    box-sizing: border-box;
    height: 24px;
    text-size-adjust: 100%;
    width: 76px;
    perspective-origin: 38px 12px;
    transform-origin: 38px 12px;
    background: rgba(99, 177, 137, 0.63) none repeat scroll 0% 0% / auto padding-box border-box;
}
.msg {
    position: absolute;
    padding: 3px 5px 0 5px;
}

`, "",{"version":3,"sources":["webpack://./src/components/helpers/load-progress-bar.vue"],"names":[],"mappings":";AAqCA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;AACA;AAEA;IACA,sBAAA;IACA,YAAA;IACA,sBAAA;IACA,YAAA;IACA,8BAAA;IACA,4BAAA;IACA,sBAAA;IACA,kBAAA;AACA;AAEA;AACA;QACA,WAAA;AACA;AAEA;QACA,WAAA;AACA;AACA;AAEA;IACA,sBAAA;IACA,YAAA;IACA,sBAAA;IACA,WAAA;IACA,6BAAA;IACA,2BAAA;IACA,2FAAA;AACA;AAEA;IACA,kBAAA;IACA,sBAAA;AACA","sourcesContent":["<template>\n    <div v-if=\"display\" class=\"load-progress-bar-container\">\n        <div class=\"border\">\n            <div class=\"msg\">{{loadMsg}}</div>\n            <div class=\"progress\" :style=\"styleProgress\" />\n        </div>\n    </div>\n</template>\n<script>\n\nexport default {\n    name: 'load-progress-bar',\n    props: {\n        display: Boolean,\n        current: Number,\n        total: Number,\n        description: {\n            type: String,\n            default: 'Shows'\n        }\n    },\n    computed: {\n        loadMsg() {\n            const { current, total, description } = this;\n            return `Loaded ${current} out of ${total} ${description}`;\n        },\n        styleProgress() {\n            const { current, total } = this;\n            return ({\n                height: '24px',\n                width: `${Math.round(current / total * 100)}%`\n            });\n        }\n    }\n};\n</script>\n<style>\n.load-progress-bar-container {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n\n.border {\n    box-sizing: border-box;\n    height: 26px;\n    text-size-adjust: 100%;\n    width: 382px;\n    perspective-origin: 191px 13px;\n    transform-origin: 191px 13px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n@media (max-width: 767px) {\n    .border {\n        width: 100%;\n    }\n\n    .load-progress-bar-container {\n        width: 100%;\n    }\n}\n\n.progress {\n    box-sizing: border-box;\n    height: 24px;\n    text-size-adjust: 100%;\n    width: 76px;\n    perspective-origin: 38px 12px;\n    transform-origin: 38px 12px;\n    background: rgba(99, 177, 137, 0.63) none repeat scroll 0% 0% / auto padding-box border-box;\n}\n\n.msg {\n    position: absolute;\n    padding: 3px 5px 0 5px;\n}\n\n</style>\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
